import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const TopBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  };

  return (
    <a href="/#contact" onClick={handleClick} className="block w-full bg-primary py-2 text-center text-xs uppercase tracking-widest text-white hover:bg-orange-700 transition-colors">
      Mumbai's Premier Bespoke Tailoring — <span className="underline">Book an Appointment</span>
    </a>
  );
};

export default TopBar;
